import { colors, ListItemButton, styled, Typography } from "@mui/material";
import { SxProps } from "@mui/system";
import { MiscSavio, StyleguideSavioColors, StyleguideSavioFonts } from "../../../configuration/themeSettings";
import CircleButtonBig from "../../../components/AppButtons/CircleButtonBig";

export const Root = styled("div", { label: "homePage" })
  (() => ({
    display: "flex",
    flex: 1,
    flexDirection: "column",
    flexGrow: 1,
    width: '100%',
    maxWidth: MiscSavio.maxWidthSite,
    

   
  }));

export const HomeSiteContainer = styled("div", { label: "home-site_container" })
  (({ theme }) => ({
    display: "flex",
    justifyContent: "center",
    width: "50%",
  }))

export const CustomeSiteText = styled(Typography, { label: "home-customer_site_text" })
  (({ theme }) => ({
    fontWeight: StyleguideSavioFonts.bold,
  }))

export const AddressSiteText = styled("span", { label: "home-address_site_text" })
  (({ theme }) => ({
    fontWeight: StyleguideSavioFonts.medium,
    fontSize: 17,
    lineHeight: 'normal',
    marginTop: 6,
    display: 'block',

  }))

export const HomeSite = styled("div", { label: "home-site" })(({ theme }) => ({
  padding: 30,
  background: theme.palette.primary.main,
  textAlign: "start",
  display: "flex",
  alignItems: "flex-start",
  opacity: 0.9,
  minWidth: "80%",
  maxWidth: "80%",
  position: "relative",
  justifyContent: "space-between",
  flexDirection: "column",
  color: theme.palette.common.white,
}));

export const ButtonGoToCustomerSite = styled(CircleButtonBig, { label: "home-site_icon_button" })
  (({ theme }) => ({
    position: "absolute",
    right: "calc(0% - 37px) !important",
    top: "calc(50% - 37px) !important",
  }))

export const Content = styled("div", { label: "home-content" })(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  position: "relative",
  flexGrow: 1,
  zIndex: 1,
}));

export const HomeImage = styled("div", { label: "home-img" })(({ theme }) => ({
  flexGrow: 1,
  width: "100%",
  marginBottom: 100,
  backgroundSize: "cover",
  backgroundPosition: "100% 80%",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-around",
}));

export const Title = styled("p", { label: "home-title" })(({ theme }) => ({
  color: StyleguideSavioColors.text.grayTitles,
  textAlign: "end",
  padding: 15,
  fontSize: 20,
  marginTop: 5,
  marginBottom: 5,

  "b": {
    fontWeight: StyleguideSavioFonts.bold,
  }
}));

export const Band = styled("div", { label: "home-band" })(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  height: 265,
  width: '100%',
  display: 'block',
  position: 'fixed',
  left: 0,
  bottom: 0,
  zIndex: 0,
}));

export const TextSelected = styled(Typography, { label: "home-selected-customer" })(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  height: 265,
  width: '100%',
  display: 'block',
  position: 'fixed',
  left: 0,
  bottom: 0,
  zIndex: 0,
}));

export const TextCustomer = styled(Typography, { label: "home-selected-text-customer" })(({ theme }) => ({
  fontSize: 30,
  fontWeight: StyleguideSavioFonts.medium,
  lineHeight: '28px',
}));